<template>
  <Layout>
    <client-only>
      <ScreenTip />
    </client-only>
    <LazyLayoutHeader class="app-layout-header" position="fixed">
      <CommonContainer class-name="app-layout-header-container">
        <CommonNav>
          <template #logo>
            <CommonLogo :is-link="false">
              <template #icon>
                <img class="app-nav-logo" :src="logo" alt="logo" />
              </template>
            </CommonLogo>
          </template>
          <!--  在webstorm中props限制了类型且基于nuxt3自动导入ref导致类型报错, 需手动导入ref -->
          <CommonLang
            v-if="langList.length > 1"
            v-model:open="langOpen"
            :class="['app-menu-lang', langOpen && 'show']"
            :list="langList"
            :mask="false"
            :global="globalLang"
          />
        </CommonNav>
      </CommonContainer>
    </LazyLayoutHeader>
    <LayoutMain>
      <slot />
    </LayoutMain>
  </Layout>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
import ScreenTip from '@/components/common/screen-tip/index.vue'

const langOpen = ref(false)

// config data
const { config } = storeToRefs(useStore())
// nav data
const langList = computed(() => config.value.lang_list)
const globalLang = computed(() => config.value.lang_list.some((item) => item.region === 'GLOBAL'))
const logo = computed(() => config.value.footer.logo)
</script>
<style lang="scss">
.app-nav-btn {
  margin-left: 30px;
}
/* --- Header --- */
.app-layout-header {
  background-color: transparent !important;
}
.app-layout-header-container {
  height: auto !important;
  width: 100% !important;
  max-width: 100% !important;
  padding: 30px 100px;
}
.layout-footer-lang .com-lang-global {
  width: 20px;
  height: 20px;
}
@media not all and (min-width: 1024px) {
  .layout-footer-lang {
    display: none;
  }
  .app-layout-header-container {
    padding: 0 30px 0 40px;
  }
  .app-nav-logo {
    width: 320px;
    height: 80px;
    object-fit: contain;
  }
  .app-footer-logo {
    width: 240px;
    height: 60px;
    object-fit: contain;
  }
  @media screen and (orientation: landscape) {
    .app-footer-logo {
      width: min(22vw, 42vh);
      height: auto;
      max-height: 12vh;
    }
  }
}
@media screen and (min-width: 1024px) {
  .layout-footer-contact {
    max-width: 25%;
    order: 2;
    margin-top: 1rem;
  }
  .app-nav-logo {
    width: 280px;
    height: 70px;
    object-fit: contain;
    position: relative;
    top: 4px;
  }
  .app-footer-logo {
    width: 240px;
    height: 60px;
    object-fit: contain;
  }
}
</style>
